<template>
  <div class="flex flex-col items-center">
    <div v-if="showLabel" class="ml-px block text-2xl text-slate-300 font-sans font-semibold leading-6">{{ label }}</div>
    <div v-if="showLabel" class="ml-px block my-2 text-sm text-slate-400 font-sans font-normal leading-6">{{ description }}</div>
    <div class="relative mt-2 w-full rounded-3xl border-0 pl-2 pr-14 py-2 bg-slate-600 shadow-sm transition-all duration-300 has-[:focus]:outline-none has-[:focus]:ring-4 has-[:focus]:ring-green-200">
      <textarea
        ref="userQueryTextarea"
        type="text"
        auto-resize
        name="userQuery"
        rows="1"
        v-model="userQuery"
        class="text-gray-100 text-lg leading-6 border-0 block w-full bg-transparent resize-none focus:ring-0 placeholder:text-gray-400 custom-scrollbar"
        :placeholder="placeholder"
        @keydown="handleKeyDown"
      />
      <div class="absolute right-0 bottom-2.5 flex items-center pr-3">
        <button @click="onInput" type="button" :class="['rounded-full p-1 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600', sendButtonClass]">
          <ArrowUpIcon class="h-7 w-7" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, watch } from 'vue';
  import { ArrowUpIcon } from '@heroicons/vue/20/solid';

  const props = defineProps({
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
    label: {
      type: String,
      required: false,
      default: 'How can I help ?',
    },
    description: {
      type: String,
      required: false,
      default: 'I can analyze this data and answer questions',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Ask me questions about data ...',
    },
    suggestions: {
      type: Array,
      default: () => {
        return [];
      },
    },
  });

  const emit = defineEmits(['userInput']);

  const userQueryTextarea = ref(null);
  const userQuery = ref('');

  const sendButtonClass = computed(() => {
    return userQuery.value === '' ? 'bg-slate-500 text-gray-400 cursor-not-allowed' : 'bg-white hover:bg-slate-200 text-black cursor-pointer';
  });

  watch(userQuery, (newValue) => {
    let inputRows = newValue.split('\n').length;
    if (inputRows === userQueryTextarea.value.rows) {
      return;
    }
    if (inputRows > 4) {
      inputRows = 5;
    }
    userQueryTextarea.value.rows = inputRows;
  });

  function handleKeyDown(event) {
    // Check if only the Enter key is pressed without Ctrl or Shift
    if (event.key === 'Enter' && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      onInput();
    }
    // If Ctrl+Enter or Shift+Enter, allow default behavior
  }

  function onInput() {
    //userQueryTextarea.value.rows = 4;
    emit('userInput', userQuery.value);
    userQuery.value = '';
  }
</script>
